import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import CardWidgetTextInput from '../CardWidgetTextInput';
import CardWidgetInputErrorHOC from "./CardWidgetInputErrorHOC";

class CardWidgetTextInputWithErrors extends Component {
  render() {
    return (
        <CardWidgetTextInput fieldLabel={this.props.fieldLabel} onChange={this.props.onChange} onBlur={this.props.onBlur} maxLength={this.props.maxLength}/>
    );
  }
}

CardWidgetTextInputWithErrors.propTypes = {
  fieldLabel: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  errorMessage: PropTypes.string,
  maxLength: PropTypes.string
};

export default CardWidgetInputErrorHOC(CardWidgetTextInputWithErrors);